module.exports = __webpack_public_path__ + "static/media/registration_check.fa5cd866.svg";